// recon-assets-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'rca.item.acqCapitalized': '{supplier} — capitalized purchase',
  'rca.item.acqExpensed': '{supplier} — expensed purchase',
  'rca.item.acqCapitalizedDesc': '{supplier} — capitalized purchase ({description})',
  'rca.item.acqExpensedDesc': '{supplier} — expensed purchase ({description})',
  'rca.item.docMissing': '{name} — purchase documentation missing',
  'rca.item.noDepreciation': '{name} — no depreciation calculated for {year}',
  'rca.item.fullyDepreciated': '{name} — fully depreciated and still in the register',
  'rca.item.negativeValue': '{name} — negative book value in the register',
  'rca.item.depDeviates': '{label} — booked depreciation differs from the register',
  'rca.item.depNotBooked': '{label} — this year\'s depreciation has not been booked',
  'rca.item.unregisteredDisposal': '{name} — credit posting on a fixed asset account without a registered disposal',
  'rca.item.registeredDisposal': '{name} — disposal registered in the period',
  'rca.item.directPosting': 'Direct posting on account {account}',
  'rca.item.directPostingDesc': 'Direct posting on account {account} — {description}',
  'rca.fallback.purchase': 'Purchase',
  'rca.fallback.creditOnAssetAccount': 'Credit posting on fixed asset account',
  'rca.src.ledger.label': 'General ledger and trial balance',
  'rca.src.ledger.detail': 'Up to and including {date}',
  'rca.src.register.label': 'Fixed asset register',
  'rca.src.register.detailOne': '{count} asset in the register',
  'rca.src.register.detailMany': '{count} assets in the register',
  'rca.src.register.detailUnavailable': 'The register could not be read for {year}',
  'rca.src.purchaseDocs.label': 'Purchase documentation for capitalized assets',
  'rca.src.purchaseDocs.detailOne': '{count} asset is missing a voucher',
  'rca.src.purchaseDocs.detailMany': '{count} assets are missing a voucher',
  'rca.src.purchaseDocs.detailAll': 'All registered assets have a voucher',
  'rca.src.depBasis.label': 'Depreciation basis from the register',
  'rca.src.depBasis.detailMissing': '{count} assets without calculated depreciation for {year}',
  'rca.src.depBasis.detailOk': 'The register has depreciation for {year} on all assets in use',
  'rca.src.disposalDocs.label': 'Documentation for disposals',
  'rca.src.disposalDocs.detailMissing': '{count} registered disposal without a voucher',
  'rca.src.disposalDocs.detailOk': 'Registered disposals have vouchers',
  'rca.src.disposalDocs.detailNone': 'No disposals in the period',
  'rca.src.acquisitions.label': 'Supplier vouchers in the period',
  'rca.src.acquisitions.detail': '{count} purchases analysed against the capitalization threshold',
  'rca.src.physical.label': 'Documentation of physical inspection',
  'rca.src.physical.detail': 'Confirms that the assets exist. Upload it as documentation on the area.',
  'rca.src.insurance.label': 'Insurance and pledge overview',
  'rca.src.insurance.detail': 'Confirms ownership and encumbrances. Upload it as documentation on the area.',
  'rca.check.registerVsLedger': 'The fixed asset register has been compared with the general ledger',
  'rca.check.accounts': 'All fixed asset accounts in the ledger are included',
  'rca.check.additions': 'Additions in the period have been analysed',
  'rca.check.additionsInfo': '{count} purchases',
  'rca.check.disposals': 'Disposals have been analysed',
  'rca.check.proceeds': 'Proceeds on disposal have been booked',
  'rca.check.gain': 'Gain and loss on disposal have been calculated',
  'rca.check.depreciation': 'Booked depreciation has been compared with the register',
  'rca.check.directPostings': 'Direct postings on fixed asset accounts have been identified',
  'rca.check.capitalization': 'Larger expensed purchases have been analysed',
  'rca.check.negative': 'Negative book values have been checked',
  'rca.check.fullyDepreciated': 'Fully depreciated assets have been identified',
  'rca.check.documentation': 'Missing purchase documentation has been identified',
  'rca.check.noPlan': 'Assets without calculated depreciation have been identified',
});
